<template>
  <div class="exchange-code-order-mgt">
    <ComList
      ref="comListRef"
      :formItem="formItem"
      :tableItem="tableItem"
      :buttonItem="buttonItem"
      :dataPro="dataPro"
      :showTenant="false" 
       v-model:multipleSelection="multipleSelection"
    >
    </ComList>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import ComList from "@/components/comList/index.vue";
import request from "@/utils/request.ts";
import API_CONFIG from './api.json';

// 定义数据类型
interface ExchangeCodeOrder {
  id: string;
  tenantCode: string;
  batchNo: string;
  exchangeCode: string;
  validDays: number;
  status: number;
  userId: string;
  productName: string;
  specName: string;
  sku: string;
  remark: string;
  createTime: string;
}

// 状态管理
const comListRef = ref<any>(null);
const multipleSelection = ref<any>([]);

// 筛选条件配置
const formItem = ref([
  {
    label: "兑换批次号",
    prop: "batchNo",
    width: 120,
    type: "input"
  },
  {
    label: "用户ID",
    prop: "userId",
    width: 100,
    type: "input"
  },
  {
    label: "商品名称",
    prop: "productName",
    width: 100,
    type: "input"
  },
   {
    label: "规格名称",
    prop: "specName",
    width: 100,
    type: "input"
  }
]);

// 表格列配置
const tableItem = ref([
  {
    label: "租户编码",
    prop: "tenantCode",
  },
  {
    label: "兑换批次号",
    prop: "batchNo",
  },
  {
    label: "兑换码",
    prop: "exchangeCode",
  },
  {
    label: "用户ID",
    prop: "userId",
  },
  {
    label: "商品名称",
    prop: "productName",
  },
  {
    label: "规格名称",
    prop: "specName",
  },
  {
    label: "SKU",
    prop: "sku",
  },
  {
    label: "备注",
    prop: "remark",
  },
  {
    label: "创建时间",
    prop: "createTime",
  },
  {
    label: "操作",
    prop: '',
    width: 180,
    type: "custom",
    fixed: "right",
    opeList: [
      {
        label: "补发兑换码",
        type: "edit",
        click: (row: ExchangeCodeOrder) => handleEdit(row)
      }
    ]

  }
]);

// 按钮配置
const buttonItem = ref([
  {
    label: "补发",
    type: "custom",
    click: ()=>{}
  },
  {
    label: "导出",
    type: "export",
    url: API_CONFIG.exportExchangeCodeOrder.url
  }
]);

// 数据源配置
const dataPro = null
//  async (pageInfo: any, searchParams: any) => {
//   try {
//     const res = await request.get(API_CONFIG.getExchangeCodeOrder.url, {
//       params: {
//         page: pageInfo.pageNum,
//         pageSize: pageInfo.pageSize,
//         ...searchParams
//       }
//     });
    
//     if (res.code === 200) {
//       return {
//         list: res.data.list || [],
//         total: res.data.total || 0
//       };
//     } else {
//       ElMessage.error(res.message || '获取数据失败');
//       return { list: [], total: 0 };
//     }
//   } catch (error) {
//     ElMessage.error('网络错误，请稍后重试');
//     console.error('获取兑换码订单数据失败:', error);
//     return { list: [], total: 0 };
//   }
// };

// 方法
const getStatusType = (status: number): string => {
  switch (status) {
    case 0:
      return 'info';
    case 1:
      return 'success';
    case 2:
      return 'danger';
    default:
      return 'warning';
  }
};

const getStatusText = (status: number): string => {
  switch (status) {
    case 0:
      return '未使用';
    case 1:
      return '已使用';
    case 2:
      return '已过期';
    default:
      return '未知';
  }
};

const handleView = (row: ExchangeCodeOrder) => {
  // 查看详情逻辑
};

const handleEdit = (row: ExchangeCodeOrder) => {
  // 编辑逻辑
};


</script>

<style scoped lang="scss">
.exchange-code-order-mgt {
  height: 100vh;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}
</style>